import { Box, Table, Tbody, Td, Tr } from "@chakra-ui/react";
import React from "react";
import { customCurrencyFormat } from "../../../utils";

const MinProfitLossTable = ({ title = "", account }) => {
  return (
    <Box overflowX="auto">
      <Table variant="unstyled" textColor="#1A202C">
        <Tbody>
          <Tr borderTop="1px solid grey" fontSize="14px" fontWeight={800}>
            <Td padding={"5px 10px"} textColor={"#4A5568"}>
              TOTAL {title?.toUpperCase()}
            </Td>
            <Td textAlign="right" padding={"5px 30px"}>
              {customCurrencyFormat(account?.total, false, true, true, true)}
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
};

export default MinProfitLossTable;
